export const SET_USER = 'USER/SET_USER';
